import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

class AuthService {
  constructor() {
    this.client = axios.create({
      baseURL: API_BASE_URL,
      withCredentials: true // Send cookies with requests
    })
  }

  /**
   * Login with username and password
   * @param {string} username
   * @param {string} password
   * @returns {Promise<Object>} Login response
   */
  async login(username, password) {
    const response = await this.client.post('/auth/login', {
      username,
      password
    })
    return response.data
  }

  /**
   * Logout and destroy session
   * @returns {Promise<Object>} Logout response
   */
  async logout() {
    const response = await this.client.post('/auth/logout')
    return response.data
  }

  /**
   * Get Tuya access token
   * @returns {Promise<Object>} Token data { access_token, expires, region }
   */
  async getTuyaToken() {
    const response = await this.client.get('/auth/token')
    return response.data
  }
}

// Export singleton instance
export default new AuthService()
